export const OAuthConfig = {
    clientId: "511553409912-84oi54kdr0v7ln0mg9lsmtg7cubrmbff.apps.googleusercontent.com",
    redirectUri: "https://vovibookstore-pbl6.netlify.app",
    // redirectUri: "http://localhost:3000",
    authUri: "https://accounts.google.com/o/oauth2/auth",
};